var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Albums")]),_c('albums',{attrs:{"albums":_vm.albums}}),_c('create-album',{attrs:{"loggedUser":_vm.loggedUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }